import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { UserGender, UserProfile } from "@/generated-api";
import DisplayNameMainLocationDoB from "./DisplayNameMainLocationDob";
import LanguagesNationalityEthnicity from "./LanguagesNationalityEthnicity";
import OpenToField from "./OpenToField";
import SecondaryLocationField from "./SecondaryLocationField";
import ReferredByField from "./ReferredByField";
import HeightField from "./HeightField";
import YourBioField from "./YourBioField";
import SmokerTattoosDrinkingField from "./SmokerTattoosField";
import ContactInfoFields from "./ContactInfoFields";
import { useDetailsForm } from "./useDetailsForm";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useTranslation } from "@/hooks/useTranslation";

export default function WomenDetailsForm({
  user,
  useSave = false,
  onSaveSuccess,
}: {
  user: UserProfile;
  useSave?: boolean;
  onSaveSuccess?: () => void;
}) {
  const t = useTranslation();
  const { form, handleDetailsSubmit, isSubmitting } = useDetailsForm(
    user,
    onSaveSuccess || (() => {}),
    UserGender.FEMALE,
    t
  );

  return (
    <Form {...form}>
      <form
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onSubmit={form.handleSubmit(handleDetailsSubmit)}
        className="space-y-4"
      >
        <DisplayNameMainLocationDoB form={form} gender={UserGender.FEMALE} />
        <HeightField form={form} />
        <LanguagesNationalityEthnicity form={form} />
        <OpenToField form={form} />
        <SmokerTattoosDrinkingField form={form} />
        <YourBioField form={form} gender={UserGender.FEMALE} />
        <div />
        <hr />
        <Accordion
          type="single"
          collapsible
          defaultValue={useSave ? "item-1" : undefined}
        >
          <AccordionItem value="item-1" className="pb-4">
            <AccordionTrigger>
              <h3 className="text-xl font-semibold leading-none tracking-tight">
                {t.USER_FORM.LABELS.OPTIONAL_DETAILS}
              </h3>
            </AccordionTrigger>
            <AccordionContent className="space-y-4 px-1">
              <SecondaryLocationField form={form} />
              {useSave && (
                <ReferredByField
                  form={form}
                  disabled={user.referred_by !== null}
                />
              )}
              <ContactInfoFields form={form} />
              <div />
            </AccordionContent>
          </AccordionItem>
        </Accordion>
        <Button
          type="submit"
          className="w-full"
          disabled={isSubmitting || !form.formState.isDirty}
        >
          {isSubmitting
            ? t.SHARED.LABELS.SENDING_BUTTON
            : useSave
            ? t.SHARED.LABELS.SAVE_BUTTON
            : t.SHARED.LABELS.CONTINUE_BUTTON}
        </Button>
      </form>
    </Form>
  );
}
